module.exports = __webpack_public_path__ + "static/media/ethereum.355beec6.svg";